/* V21 mobile navigation. Selection changes products in place; native links stay native. */
(() => {
  'use strict';
  if (customElements.get('ov-collection-mobile')) return;
  class OvCollectionMobile extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const {signal} = this._abort;
      this._mobile = window.matchMedia('(max-width:749.98px)');
      this._panels = [...this.querySelectorAll('[data-ovm-block]')];
      this._select = this.querySelector('[data-ovm-select]');
      this._go = this.querySelector('[data-ovm-go]');
      this._controls = this.querySelector('[data-ovm-controls]');
      this._prev = this.querySelector('[data-ovm-prev]');
      this._next = this.querySelector('[data-ovm-next]');
      this._counter = this.querySelector('[data-ovm-counter]');
      this._status = this.querySelector('[data-ovm-status]');
      this._frame = 0;
      this._editorMarkers = new Map();
      this._select?.addEventListener('change', () => this.choose(this._select.value, true), {signal});
      this._prev?.addEventListener('click', () => this.step(-1), {signal});
      this._next?.addEventListener('click', () => this.step(1), {signal});
      this._panels.forEach(panel => {
        const rail = panel.querySelector('[data-ovm-rail]');
        rail?.addEventListener('scroll', () => this.schedule(), {signal, passive:true});
        rail?.addEventListener('keydown', event => {
          if (event.target !== rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault(); this.step(event.key === 'ArrowRight' ? 1 : -1);
        }, {signal});
      });
      this._mobile.addEventListener('change', () => {this.syncEditor(); this.schedule();}, {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!this._mobile.matches) return;
        const id = event.detail?.blockId;
        if (!this._panels.some(panel => panel.dataset.ovmBlock === id)) return;
        this.choose(id, false);
        this.scrollIntoView({block:'nearest', behavior:'auto'});
      }, {signal});
      this._resize = new ResizeObserver(() => this.schedule());
      this._resize.observe(this);
      this.choose(this.dataset.initial, false);
      this.syncEditor();
    }
    disconnectedCallback() {
      this.restoreEditor();
      this._abort?.abort(); this._abort = null;
      this._resize?.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
      this._frame = 0;
    }
    restoreEditor() {
      this._editorMarkers?.forEach((value, old) => {
        if (old.isConnected) old.setAttribute('data-shopify-editor-block', value);
      });
      this._panels?.forEach(panel => panel.removeAttribute('data-shopify-editor-block'));
    }
    syncEditor() {
      if (!window.Shopify?.designMode) return;
      this.restoreEditor();
      if (!this._mobile.matches) return;
      const section = this.closest('.ov-collections');
      this._panels.forEach(panel => {
        const old = section?.querySelector(`[id="Ob-${this.dataset.sectionId}-${panel.dataset.ovmBlock}"]`);
        const value = old?.getAttribute('data-shopify-editor-block');
        if (!value) return;
        this._editorMarkers.set(old, value);
        old.removeAttribute('data-shopify-editor-block');
        panel.setAttribute('data-shopify-editor-block', value);
      });
    }
    choose(id, announce) {
      const current = this._panels.find(panel => panel.dataset.ovmBlock === id) || this._panels[0];
      if (!current) return;
      this._panels.forEach(panel => {panel.hidden = panel !== current;});
      this._current = current;
      this._rail = current.querySelector('[data-ovm-rail]');
      if (this._select) this._select.value = current.dataset.ovmBlock;
      if (this._go) {
        this._go.setAttribute('href', current.dataset.url);
        this._go.setAttribute('aria-label', `${this._go.textContent.trim()}: ${current.dataset.title}`);
      }
      [this._prev, this._next].forEach(button => {
        if (button && this._rail) button.setAttribute('aria-controls', this._rail.id);
      });
      if (announce) {
        if (this._rail) this._rail.scrollLeft = 0;
        if (this._status) this._status.textContent = `Productos de ${current.dataset.title}`;
      }
      this.schedule();
    }
    schedule() {if (!this._frame) this._frame = requestAnimationFrame(() => {this._frame=0; this.update();});}
    update() {
      if (!this._mobile.matches || !this._rail) return;
      const rail = this._rail;
      const cards = [...rail.children];
      const bounds = rail.getBoundingClientRect();
      const shown = cards.map((card,i) => ({i, r:card.getBoundingClientRect()}))
        .filter(card => card.r.right > bounds.left + 4 && card.r.left < bounds.right - 4);
      const first = (shown[0]?.i ?? 0) + 1;
      const last = (shown.at(-1)?.i ?? 0) + 1;
      if (this._counter) this._counter.textContent = `${first === last ? first : `${first}–${last}`} / ${cards.length}`;
      if (this._controls) this._controls.hidden = this.dataset.layout === 'grid' || !cards.length;
      if (this._prev) this._prev.disabled = rail.scrollLeft <= 3;
      if (this._next) this._next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
    }
    step(direction) {
      if (!this._mobile.matches || !this._rail || this.dataset.layout === 'grid') return;
      const rail = this._rail;
      const cards = [...rail.children];
      const left = rail.getBoundingClientRect().left;
      const position = card => card.getBoundingClientRect().left - left + rail.scrollLeft;
      const target = direction > 0
        ? cards.find(card => position(card) > rail.scrollLeft + 4)
        : cards.slice().reverse().find(card => position(card) < rail.scrollLeft - 4);
      if (!target) return;
      rail.scrollTo({left:Math.max(0,position(target)), behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      this.schedule();
    }
  }
  customElements.define('ov-collection-mobile', OvCollectionMobile);
})();
